import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocaleElement from 'element-ui/lib/locale/lang/en';
import zhLocaleElement from 'element-ui/lib/locale/lang/zh-CN';
import zhLocaleIView from 'iview/src/locale/lang/zh-CN';
import enLocaleIView from 'iview/src/locale/lang/en-US';
import ElementLocale from 'element-ui/lib/locale';
import en from './en';
import zhCN from './zh-CN';

Vue.use(VueI18n);

const locale = 'zh-CN';

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || locale,
  fallbackLocale: locale,
  messages: {
    en: {
      ...en,
      ...enLocaleElement,
      ...enLocaleIView,
    },
    'zh-CN': {
      ...zhCN,
      ...zhLocaleElement,
      ...zhLocaleIView,
    },
  },
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

export function setLang(lang) {
  i18n.locale = lang;
  ElementLocale.i18n((key, value) => i18n.t(key, value));
  localStorage.setItem('lang', lang);
}

export default i18n;
